var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Arrow, EventsCount, EventCardDetailsAggregate } from "../../components";
let AggregateCard = class AggregateCard extends React.Component {
    constructor(props) {
        super(props);
        this.componentPrefix = "aggregate-card";
    }
    render() {
        return (React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}`, "data-uat": `div-ev-list-${this.componentPrefix}` },
            React.createElement("a", { className: `rj-ev-list__${this.componentPrefix}__link`, href: this.props.event.linkUrl, onClick: this.props.handlers.eventCard, "data-uat": `a-ev-list-${this.componentPrefix}-link` },
                React.createElement(EventsCount, { count: this.props.event.aggregatedEventsCount, componentPrefix: this.componentPrefix }),
                React.createElement(EventCardDetailsAggregate, { details: this.props, componentPrefix: this.componentPrefix }),
                React.createElement(Arrow, { componentPrefix: this.componentPrefix }))));
    }
};
AggregateCard = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], AggregateCard);
export { AggregateCard };
//# sourceMappingURL=AggregateCard.js.map